import { useCallback, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { FlexColumn } from '../../atoms/layout/Flex'
import Dialog from '../../atoms/feedback/Dialog'
import Label from '../../atoms/display/Label'
import Button from '../../atoms/inputs/Button'
import Checkbox from '../../atoms/inputs/Checkbox'
import { useAgreementAcceptDialog } from '../../../hooks/useDialog'
import { AgreementActions } from '../../../store/agreement'

export default function AgreementAcceptDialog() {
  const { state, close } = useAgreementAcceptDialog()
  const dispatch = useDispatch()
  const [confirmed, setConfirmed] = useState<boolean>(false)

  // ダイアログが開くたびにチェックボックスをリセット
  useEffect(() => {
    if (state) {
      setConfirmed(false)
    }
  }, [state])

  const handleAccept = useCallback(() => {
    if (state) {
      dispatch(AgreementActions.acceptAgreement({ agreementId: state.agreementId }))
    }
  }, [dispatch, state])

  return (
    <Dialog
      open={state !== undefined}
      title="契約の承認"
      width="md"
      actions={
        <Button onClick={handleAccept} disabled={!confirmed}>
          承認する
        </Button>
      }
      onClose={close}
    >
      <FlexColumn maxHeight="60vh" space={2}>
        <Label text="この契約を承認しますか？" />
        <Checkbox
          label="本契約書に対し、取引先から事前説明を受け、内容を十分に理解しました"
          checked={confirmed}
          onChange={setConfirmed}
        />
      </FlexColumn>
    </Dialog>
  )
}
